import qcTypeConfig from './qcTypeConfig'

const {map: QC_TYPE_MAP} = qcTypeConfig

const QC_DEVICE_LIST = [{
  value: 'VOC-MASS-SPECTRUM',
  label: 'VOC-质谱',
  // categoryId: process.env.VOCS_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 30,
    unit: '%',
    categories: [['非甲烷碳氢化合物'], ['含氧类', '卤代烃', '其他']],
    statistics: {
      defaultCtrlVal: 20
    }
  }, {
    value: 2,
    defaultCtrlVal: 0.995,
    unit: '',
    categories: [['非甲烷碳氢化合物'], ['含氧类', '卤代烃', '其他']],
    getSummaryList: (categories, categoryMap, dataList, factorNameList, realLimit) => {
      let summaryList = dataList.map(data => ({
        dataTime: data.dataTime,
        summaryMap: {}
      }))
      let totalCount = 0

      categories.forEach((categories, categoryIndex) => {
        let limit = realLimit[categoryIndex]

        categories.forEach(category => {
          let tmpFactorNameList = categoryMap[category]
          let total = tmpFactorNameList.length
          let indexList = tmpFactorNameList.map(factorName => factorNameList.indexOf(factorName))
          totalCount += total

          dataList.forEach(({data}, index) => {
            let summaryInfo = summaryList[index]
            let summaryMap = summaryInfo.summaryMap
            let count = indexList.reduce((count, index) => {
              let value = data[index]
              value = value === undefined ? -99999 : value
              return count + (value >= limit)
            }, 0)
            summaryMap[category] = {
              qualified: count,
              ratio: Math.round(count / total * 100),
              total
            }
          })
        })
      })

      return summaryList.map(({dataTime, summaryMap}) => {
        let sumQualified = summaryMap['非甲烷碳氢化合物'].qualified + summaryMap['卤代烃'].qualified + summaryMap['含氧类'].qualified + summaryMap['其他'].qualified
        return {
          dataTime,
          list: [
            `1）非甲烷碳氢化合物共计${summaryMap['非甲烷碳氢化合物'].total}种，线性相关性R≥0.995的共计${summaryMap['非甲烷碳氢化合物'].qualified}种，占比${summaryMap['非甲烷碳氢化合物'].ratio}%（要求≥85%)`,
            `2）卤代烃类化合物共计${summaryMap['卤代烃'].total}种，线性相关性R≥0.995的共计${summaryMap['卤代烃'].qualified}种,占比${summaryMap['卤代烃'].ratio}%（要求≥80%）`,
            `3）含氧类VOCs共计${summaryMap['含氧类'].total}种，线性相关性R≥0.995的共计${summaryMap['含氧类'].qualified}种,占比${summaryMap['含氧类'].ratio}%（要求≥70%）`,
            `4）线性相关性R≥0.995的共计${sumQualified}种，占比${Math.round(sumQualified / totalCount * 100)}% `,
            `5）线性相关性R＜0.995的共计${totalCount - sumQualified}种，占比${Math.round((totalCount - sumQualified) / totalCount * 100)}%`
          ]
        }
      })
    }
  }, {
    value: 3,
    defaultCtrlVal: 0.15,
    unit: 'PPB',
    categories: [['非甲烷碳氢化合物'], ['含氧类', '卤代烃', '其他']],
    siteLimit: ['d397cbf337e64a11a68d375ed950444e'],
    defaultCtrlVals: [0.15, 0.3]
  }, {
    value: 4,
    defaultCtrlVal: 10,
    unit: '%',
    categories: [['非甲烷碳氢化合物'], ['含氧类', '卤代烃', '其他']]
  }, {
    value: 6,
    defaultCtrlVal: 0.1,
    unit: 'PPB',
    categories: [['非甲烷碳氢化合物'], ['含氧类', '卤代烃', '其他']]
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%',
    categories: [['非甲烷碳氢化合物'], ['含氧类', '卤代烃', '其他']]
  }, {
    value: 12,
    defaultCtrlVal: 50,
    unit: '%'
  }]
}, {
  value: 'VOC-CHROMATOGRAPHY',
  label: 'VOC-色谱',
  // categoryId: process.env.VOCS_DEVICE_CATEGORY,
  siteLimit: ['d397cbf337e64a11a68d375ed950444e', '1cf502ab3661449ea64d9c45b7cc5b5c'],
  filter: true,
  children: [{
    value: 1,
    defaultCtrlVal: 20,
    unit: '%',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 2,
    defaultCtrlVal: 0.995,
    unit: '',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 3,
    defaultCtrlVal: 0.15,
    unit: 'PPB',
    siteLimit: ['d397cbf337e64a11a68d375ed950444e'],
    defaultCtrlVals: [0.2, 0.5],
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 4,
    defaultCtrlVal: 10,
    unit: '%',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 5,
    defaultCtrlVal: 20,
    unit: '%',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 6,
    defaultCtrlVal: 0.1,
    unit: 'PPB',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 7,
    defaultCtrlVal: 20,
    unit: 's',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 9,
    defaultCtrlVal: NaN,
    unit: '',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }, {
    value: 10,
    defaultCtrlVal: NaN,
    unit: '',
    categories: [['芳香烃', '炔烃', '烷烃', '烯烃'], ['卤代烃', '苯系物', '其他']]
  }]
}, {
  value: 'VOC-DYNAMIC-CALIBRATOR',
  label: 'VOC动态校准仪',
  categoryId: process.env.VOCS_CALIBRATOR,
  children: [{
    value: 8,
    defaultCtrlVal: 3,
    unit: '%'
  }]
}, {
  value: 'CONVENTIONAL-DYNAMIC-CALIBRATOR',
  label: '常规动态校准仪',
  categoryId: process.env.NORMAL_CALIBRATOR,
  children: [{
    value: 8,
    defaultCtrlVal: 3,
    unit: '%'
  }]
}, {
  value: 'OC-EC',
  label: 'OC/EC',
  categoryId: process.env.OCEC_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.999,
    unit: ''
  }, {
    value: 3,
    defaultCtrlVal: 0.5,
    unit: 'μg/m3'
  }, {
    value: 4,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 0.3,
    unit: 'μg'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'ION-CHROMATOGRAPHY',
  label: '离子色谱',
  categoryId: process.env.ION_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 10,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.995,
    unit: ''
  }, {
    value: 3,
    defaultCtrlVal: 10,
    unit: 'μg/L'
  }, {
    value: 4,
    defaultCtrlVal: 10,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 10,
    unit: 'μg/L'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'HEAVY-METAL',
  label: '重金属',
  categoryId: process.env.HEAVY_METAL_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 7,
    unit: '%'
  }, {
    value: 3,
    defaultCtrlVal: 1,
    unit: 'ng/m3'
  }, {
    value: 4,
    defaultCtrlVal: 10,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 10,
    unit: 'ng/m3'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'METHANE',
  label: '甲烷非甲烷',
  categoryId: process.env.NMHC_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.999,
    unit: ''
  }, {
    value: 3,
    defaultCtrlVal: 50,
    unit: 'PPB'
  }, {
    value: 4,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 50,
    unit: 'PPB'
  }]
}, {
  value: 'BENZENE-SERIES',
  label: '苯系物',
  // categoryId: process.env.VOCS_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 20,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.995,
    unit: ''
  }, {
    value: 3,
    defaultCtrlVal: 0.2,
    unit: 'PPB'
  }, {
    value: 4,
    defaultCtrlVal: 10,
    unit: '%'
  }, {
    value: 5,
    defaultCtrlVal: 20,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 0.1,
    unit: 'PPB'
  }, {
    value: 7,
    defaultCtrlVal: 20,
    unit: 's'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'PAN',
  label: 'PAN',
  categoryId: process.env.PAN_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 10,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.99,
    unit: ''
  }, {
    value: 4,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'FORMALDEHYDE',
  label: '甲醛',
  categoryId: process.env.HCHO_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 7,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.999,
    unit: ''
  }, {
    value: 4,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'ORGANIC-SULFUR',
  label: '有机硫',
  categoryId: process.env.ORGANIC_SULFUR_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 20,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.995,
    unit: ''
  }, {
    value: 3,
    defaultCtrlVal: 0.2,
    unit: 'PPB'
  }, {
    value: 4,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 5,
    defaultCtrlVal: 20,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 0.2,
    unit: 'PPB'
  }, {
    value: 7,
    defaultCtrlVal: 20,
    unit: 's'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'NO2-DIRECT-DETECTION',
  label: 'NO2直测',
  categoryId: process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.999,
    unit: ''
  }, {
    value: 4,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 4,
    unit: 'PPB'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}, {
  value: 'NOY',
  label: 'NOy',
  categoryId: process.env.NOY_DEVICE_CATEGORY,
  children: [{
    value: 1,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 2,
    defaultCtrlVal: 0.999,
    unit: ''
  }, {
    value: 4,
    defaultCtrlVal: 5,
    unit: '%'
  }, {
    value: 6,
    defaultCtrlVal: 5,
    unit: 'PPB'
  }, {
    value: 8,
    defaultCtrlVal: 5,
    unit: '%'
  }]
}]

QC_DEVICE_LIST.forEach((QC_DEVICE, index) => {
  QC_DEVICE.sort = index
  QC_DEVICE.children = QC_DEVICE.children.map(qcType => ({
    ...QC_TYPE_MAP[qcType.value],
    defaultCtrlVal: qcType.defaultCtrlVal,
    unit: qcType.unit,
    ...(qcType.categories ? {categories: qcType.categories} : {}),
    ...(qcType.statistics ? {statistics: qcType.statistics} : {}),
    ...(qcType.getSummaryList ? {getSummaryList: qcType.getSummaryList} : {}),
    ...(qcType.siteLimit ? {siteLimit: qcType.siteLimit} : {}),
    ...(qcType.defaultCtrlVals ? {defaultCtrlVals: qcType.defaultCtrlVals} : {})
  }))
})

export default {
  list: QC_DEVICE_LIST,
  map: QC_DEVICE_LIST.reduce((map, qcDeviceOpt) => {
    let value = qcDeviceOpt.categoryId || qcDeviceOpt.value
    map[value] = qcDeviceOpt
    return map
  }, {})
}



// WEBPACK FOOTER //
// ./src/utils/qcDeviceConfig.js